var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSettings(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M19.1562 20.897L21.3733 18.6798L20.5925 15.843L20.9327 15.0305L23.5 13.5818V10.4464L20.94 8.99173L20.6055 8.18067L21.3961 5.34235L19.1774 3.12683L16.3403 3.90748L15.5296 3.56758L14.0808 1H10.9454L9.49072 3.56004L8.67985 3.89446L5.84198 3.10281L3.6267 5.31809L4.40748 8.15567L4.06758 8.96634L1.5 10.4151V13.5496L4.05774 15.0076L4.39252 15.8193L3.60197 18.6572L5.81809 20.8733L8.65567 20.0925L9.46644 20.4325L10.9153 22.999H14.0498L15.5067 20.4412L16.3183 20.1065L19.1562 20.897ZM19.3527 13.6256L18.4809 15.7078L19.1362 18.0886L18.5678 18.657L16.192 17.9951L14.109 18.8542L12.8873 20.999H12.0829L10.8714 18.8529L8.79155 17.9808L6.40947 18.6362L5.84203 18.0688L6.50385 15.693L5.64482 13.6101L3.5 12.3876V11.583L5.6471 10.3715L6.5192 8.29155L5.86375 5.90947L6.43001 5.34321L8.80576 6.00595L10.8895 5.14655L12.1093 3H12.9129L14.1245 5.1471L16.2044 6.0192L18.587 5.36362L19.1558 5.93166L18.4941 8.30696L19.3534 10.3906L21.5 11.6103V12.4139L19.3527 13.6256ZM12.5 16C10.2909 16 8.5 14.2091 8.5 12C8.5 9.79086 10.2909 8 12.5 8C14.7091 8 16.5 9.79086 16.5 12C16.5 14.2091 14.7091 16 12.5 16ZM14.5 12C14.5 13.1046 13.6046 14 12.5 14C11.3954 14 10.5 13.1046 10.5 12C10.5 10.8954 11.3954 10 12.5 10C13.6046 10 14.5 10.8954 14.5 12Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSettings);
export default __webpack_public_path__ + "static/media/settings.89f5ff9d.svg";
export { ForwardRef as ReactComponent };